module.exports = __webpack_public_path__ + "img/ar.3ca90e4a.svg";